<div class="modal-backdrop-custom" (click)="modal.close()">
	<div class="modal-card">
		<i class="bi bi-x bi-lg fs-4 ms-auto pointer" style="position: relative;right: -40%;top:-20px" (click)="modal.close()"></i>

		<div class="modal-icon" style="background: #fdf6ec; border: none;">
			<i class="bi bi-exclamation-triangle" style="color: #f39c12; font-size: 28px;"></i>
		</div>
		<div class="modal-title" translate>{{title}}</div>
		<div class="modal-subtitle" translate>{{message}}</div>
	</div>
</div>
